import React from 'react';
import { CopyButton } from '../../../../global/copy-button/copy-button';
import DefaultButton from '../../../../global/default-button/default-button';
import './link-item.scss';
import { LinkTargetValue } from '../../../../../constants/common.constants';
import { openText } from '../../../../../constants/common-labels.constants';

type Props = {
    url: string;
};

export const LinkItemButtons = (props: Props) => {
    const openLink = (url: string): void => {
        window.open(url, LinkTargetValue.BLANK);
    };

    return (
        <div className='event-link__item-buttons'>
            <CopyButton copyValue={props.url} withoutIcon />
            <DefaultButton
                className='small-button'
                text={openText()}
                onClick={openLink.bind(null, props.url)}
            />
        </div>

    );
};
